import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=2a89d48e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=2a89d48e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a89d48e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a89d48e')) {
      api.createRecord('2a89d48e', component.options)
    } else {
      api.reload('2a89d48e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=2a89d48e&scoped=true&", function () {
      api.rerender('2a89d48e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23ho07D2vrbu6/JS/comp/DocBox.vue"
export default component.exports